import React from "react";
import { Link } from "react-router-dom";

const GitHubLink = ({ youtubeURL, text }) => {
  return (
    <Link
      to={youtubeURL}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="tag youTube">
        {text ? (
          <span className="tagText">{text}</span>
        ) : (
          <span className="tagText">View on YouTube</span>
        )}
      </div>
    </Link>
  );
};

export default GitHubLink;
